import { Adapter as e, getAdapter as t } from "../../../adapter.js";
import { GoogleAnalyticsModel as o } from "./google.model.js";
import { GoogleAnalyticsPlatformAdapter as r } from "./googleAnalyticsPlatform.adapter.js";
import { GoogleTagManagerAdapter as l } from "./googleTagManager.adapter.js";
class n extends e {
  adapt(a) {
    return new o({
      status: a.status,
      ga: a.analytics ? t(r).adapt(a.analytics) : void 0,
      gtm: a.tag_manager ? t(l).adapt(a.tag_manager) : void 0
    });
  }
  serialize(a) {
  }
}
export {
  n as GoogleAnalyticsAdapter
};
//# sourceMappingURL=google.adapter.js.map
